import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <span className="text-2xl">📯</span>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white">Trump of the Lord</span>
                <span className="text-xs text-gray-400">Ministries</span>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              Teaching post-tribulational truth through plain grammatical analysis of Scripture.
            </p>
            <div className="flex space-x-3">
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="mailto:contact@trumpofthelord.com" className="hover:text-white transition-colors" title="Email us">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Store */}
          <div>
            <h3 className="text-white font-semibold mb-4">Store</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/store/books" className="hover:text-white transition-colors">Books</Link></li>
              <li><Link to="/store/ebooks" className="hover:text-white transition-colors">Ebooks</Link></li>
              <li><Link to="/store/shofars" className="hover:text-white transition-colors">Shofars</Link></li>
              <li><Link to="/store/apothecary" className="hover:text-white transition-colors">Apothecary</Link></li>
              <li><Link to="/store/bundles" className="hover:text-white transition-colors">Bundles</Link></li>
            </ul>
          </div>

          {/* Ministry */}
          <div>
            <h3 className="text-white font-semibold mb-4">Ministry</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/subscriptions" className="hover:text-white transition-colors">Subscriptions</Link></li>
              <li><Link to="/kingdom-guard" className="hover:text-white transition-colors">Kingdom Escort Guard</Link></li>
              <li><Link to="/media" className="hover:text-white transition-colors">Podcast & Videos</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About Mordecai</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-white font-semibold mb-4">Stay Connected</h3>
            <p className="text-sm text-gray-400 mb-4">
              Join our newsletter for weekly teachings and updates.
            </p>
            <p className="text-sm text-gray-400 mb-4">
              Contact us: <a href="mailto:contact@trumpofthelord.com" className="text-blue-400 hover:text-blue-300">contact@trumpofthelord.com</a>
            </p>
            <p className="text-sm text-gray-400 mb-4">
              Support: <a href="mailto:support@trumpofthelord.com" className="text-blue-400 hover:text-blue-300">support@trumpofthelord.com</a>
            </p>
            <form className="space-y-2">
              <input
                type="email"
                placeholder="Your email"
                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-md text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md text-sm transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
          <p>&copy; 2026 Trump of the Lord Ministries. Curtis Alexander Fenison (Mordecai). All rights reserved.</p>
          <p className="mt-2">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            {' · '}
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
